/**
 * Customizes our jQuery setup
 */

import Backbone from 'backbone'

import $ from 'jquery'
import scoreboardUrl from 'scoreboard/components/scoreboard-url'
import errors from 'scoreboard/components/setup-errors'
import Xhr from 'scoreboard/components/xhr'
import constants from 'scoreboard/components/constants'
import { XHR_HEADERS_AVAILABLE } from 'scoreboard/components/permissions'

function setupJQuery() {
	// Spring serializes arrays the same way they would be serialized if you
	// sent things through an HTML form, not in the fancier way jQuery,
	// Ruby on Rails and some other frameworks support
	// see https://api.jquery.com/jQuery.param/
	$.ajaxSettings.traditional = true

	$.ajaxSetup({
		// all our requests should be JSON except file uploads.
		contentType: constants.CONTENT_TYPES.APPLICATION_JSON,
		beforeSend: function(xhr, options) {
			Xhr.setCsrfToken(xhr)
			// fix URLs so our app can be hosted at the root or not
			options.url = scoreboardUrl(options.url)
			var originalSuccess = options.success
			options.success = function(data, textStatus, jqXhr) {
				Backbone.trigger(XHR_HEADERS_AVAILABLE, jqXhr)
				originalSuccess && originalSuccess.apply(this, arguments)
			}
		}
	})

	// This is called AFTER any declared error handlers, and is the final catch-all for errors
	// Do not put any error handling logic here, that belongs in display-error-handler.js
	$(document).ajaxError(function(event, xhr, options, thrownError) {
		errors.errorHandler(xhr, options)
	})

	// from http://stepansuvorov.com/blog/2014/04/jquery-put-and-delete/

	$.put = function(url, data, callback, type){

		if ( $.isFunction(data) ){
			type = type || callback,
			callback = data,
			data = {}
		}

		return $.ajax({
			url: url,
			type: 'PUT',
			success: callback,
			data: data,
			contentType: type
		});
	}

	$.delete = function(url, data, callback, type){

		if ( $.isFunction(data) ){
			type = type || callback,
					callback = data,
					data = {}
		}

		return $.ajax({
			url: url,
			type: 'DELETE',
			success: callback,
			data: data,
			contentType: type
		});
	}

}


export default setupJQuery

setupJQuery.__filename__ = 'setup-jquery.js'
